(function() {
  if (window.location.search.indexOf("contact_posted=true") === -1) return;

  var data = {};
  try { data = JSON.parse(sessionStorage.getItem("sj_kurulum") || "{}"); } catch(e) {}

  if (!data.email) return;

  var xhr = new XMLHttpRequest();
  xhr.open("POST", "https://api.airtable.com/v0/appJgC3GIRqr15hd6/tblGSnhJiDMdNKdsZ", false);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.setRequestHeader("Authorization", "Bearer patsT35cPQ0MNoi5H.91bbd8c66ff170db6a513f509aef266103b83704c17c51e41f704cd5ce5c5408");
  xhr.send(JSON.stringify({ fields: data }));

  sessionStorage.removeItem("sj_kurulum");
})();

(function waitForForm() {
  var form = document.getElementById("sarjelek-kurulum-form");
  if (!form) { setTimeout(waitForForm, 100); return; }

  var inputs = form.querySelectorAll("input, select, textarea");
  inputs.forEach(function(input) {
    input.addEventListener("change", function() {
      var formData = new FormData(form);
      sessionStorage.setItem("sj_kurulum", JSON.stringify({
        "Isim": formData.get("contact[first_name]") || "",
        "Soyisim": formData.get("contact[last_name]") || "",
        "E-mail": formData.get("contact[email]") || "",
        "Numara": formData.get("contact[phone]") || "",
        "Konu": formData.get("contact[subject]") || "",
        "Mesaj": formData.get("contact[body]") || "",
        "Promosyon Kodu": formData.get("contact[\u0130ndirim Kodu]") || "",
        "Kanal": formData.get("contact[Geli\u015f Kanal\u0131]") || "Shopify Kurulum",
        "Sayfa": window.location.href
      }));
    });
  });
})();